<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" v-loading="loading" :element-loading-text="loadingText">
    <div class="zj-plan-task-com-sett">
      <el-tabs class="setting-tabs no-active-bar" v-model="activeName">
        <el-tab-pane
          :key="item.code"
          v-for="(item) in EmergencyTaskSubType"
          :label="item.value"
          :name="item.code"
          :disabled="form.id && activeName != item.code ? true : false"
        >
          <ComponentSMSDetail
            v-if="item.code=='sms'"
            :ref="item.code"
            :PlanTaskId="taskId"
            :TaskSubTypeId="item.code"
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :form="form"
          />
          <!-- <ComponentLEDDetail
            v-if="item.code=='led'"
            :ref="item.code"
            :PlanTaskId="taskId"
            :TaskSubTypeId="item.code"
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :form="form"
          /> -->
          <ComponentradioDetail
            v-if="item.code=='broadcast'"
            :ref="item.code"
            :PlanTaskId="taskId"
            :TaskSubTypeId="item.code"
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :form="form"
          />
          <!-- <ComponentWeChatDetail
            v-if="item.code=='weChat'"
            :ref="item.code"
            :PlanTaskId="taskId"
            :TaskSubTypeId="item.code"
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :form="form"
          />
          <ComponentAPPDetail
            v-if="item.code=='keepwatch'"
            :ref="item.code"
            :PlanTaskId="taskId"
            :TaskSubTypeId="item.code"
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :form="form"
          />
          <ComponentAPPDetail
            v-if="item.code=='manageApp'"
            :ref="item.code"
            :PlanTaskId="taskId"
            :TaskSubTypeId="item.code"
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :form="form"
          /> -->
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-form>
</template>
<script>
import ComponentSMSDetail from "./ComponentSMSDetail";
import ComponentLEDDetail from "./ComponentLEDDetail";
import ComponentradioDetail from "./ComponentradioDetail";
import ComponentAPPDetail from "./ComponentAPPDetail";
import ComponentWeChatDetail from "./ComponentWeChatDetail";

import MyApis from "../../../apis";

import { getDictionary } from "@/api/src/emergency_common";
import { list } from "@/api/src/emergency_plan_task";
export default {
  name: "ZjCommunicationSettingInfo",
  controller: "UI",
  action: "CommunicationSettingInfo",
  components: {
    ComponentSMSDetail,
    ComponentLEDDetail,
    ComponentradioDetail,
    ComponentAPPDetail,
    ComponentWeChatDetail
  },
  props: {
    id: { type: String },
    form: { type: Object },
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      activeName: "",
      EmergencyTaskSubType: [],
      ruleForm: {
        taskId: this.$props.taskId
      }
    };
  },
  created: function() {
    this.loadingRef = 0;
    this.showLoading('加载中...');
    getDictionary('emergency_task_communication_type')
      .then(d => {
        var data = d.data.records;
        if (data) {
          this.activeName = data[0].code;
          this.EmergencyTaskSubType = data;
          this.hideLoading();
          // this.search();
        }
      })
      .catch(e => {
        console.error(e);
        this.hideLoading();
      });
  },
  methods: {
    showLoading(text) {
      this.loadingRef++;
      this.loading = true;
      this.loadingText = typeof(text) !== 'undefined' && text !== null ? text : '加载中...'
    },
    hideLoading() {
      this.loadingRef--;
      if (this.loadingRef == 0) {
        this.loading = false;
      }
    },
    search() {
      let id = this.$props.taskId;
      if (id != null && id != "") {
        this.showLoading('加载中...');
        list(id)
          .then(r => {
            var data = r.data;
            if (data.length > 0) {
              this.ruleForm = data;
            }
            this.hideLoading();
          })
          .catch(e => {
            console.error(e);
            this.hideLoading();
          });
      }
    },
  },
  watch:{
    'form':{
      handler(val, oldVal) {
        if (val.broadcast) {
          this.activeName = 'broadcast'
        }else if(val.sms){
          this.activeName = 'sms'
        }
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>
<style>
.zj-plan-task-com-sett
  > .setting-tabs
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .is-active {
  background: url(/img/tabselected.png) no-repeat !important;
  background-size: 100% 100% !important;
  background-position: center !important;
}
.zj-plan-task-com-sett
  > .setting-tabs
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .el-tabs__active-bar {
  display: none;
}
.zj-plan-task-com-sett .el-tabs__item {
  width: 16rem;
  text-align: -webkit-center;
}
.zj-plan-task-com-sett
  > .setting-tabs
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll
  > .el-tabs__nav
  > .el-tabs__item {
  background: url(/img/tab.png) no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
</style>>
